<template>
  <div class="container">
    <div class="page-content">
      <!-- 功能网格 -->
      <div class="feature-grid">
        <div class="feature-item item-sr" @click="goTo('/szmx/sr')">
          <div class="feature-icon">
            <img src="../../assets/newicon/wyfsr.png" alt="物业费收入" />
          </div>
          <div class="feature-text">物业费收入</div>
        </div>
        <div class="feature-item item-zc" @click="goTo('/szmx/zc')">
          <div class="feature-icon">
            <img src="../../assets/newicon/jfmx1.png" alt="物业费支出" />
          </div>
          <div class="feature-text">物业费支出</div>
        </div>
        <div class="feature-item item-mx" @click="goTo('/szmx/jfqk')">
          <div class="feature-icon">
            <img src="../../assets/newicon/wyfzc1.png" alt="收支明细" />
          </div>
          <div class="feature-text">缴费明细</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SzmxIndex',
  data() {
    return {}
  },
  methods: {
    goTo(path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  // background-color: #f5f5f5;
}

.page-content {
  padding: 24px 16px;
}

.feature-grid {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.feature-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 20px 8px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.feature-item:active {
  transform: scale(0.95);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.feature-item.item-sr {
  background-color: #F5F8FF;
}

.feature-item.item-zc {
  background-color: #F5F8FF;
  // background-color: #FFF1EE;
}

.feature-item.item-mx {
  background-color: #F5F8FF;
  // background-color: #FEF7EC;
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 54px;
    height: 54px;
    object-fit: contain;
  }
}

.feature-text {
  font-size: 15px;
  color: #333;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
}
</style>
